import React, { Fragment, useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { H4 } from "../../../../AbstractElements";
import useAxios from "../../../../Utils/useAxios";
import { convertRPInputToIntValue } from "../../../../Utils/otherFunctions";
import { formatRP, formatTimestamp } from "../../../../Utils/externalFunctions";
import {
  APISentSuccessMsg,
  getItemCreateSuccessMsg,
  getItemEditSuccessMsg,
} from "../../../../Constant/Message";
import { toast } from "react-toastify";
import { timeToast } from "../../../../Constant";
import { FORM_TYPE } from "../../../../Constant/FormType";
import { useNavigate } from "react-router-dom";
import getUnitKerja from "../services/getUnitKerja";
import getPerspektif from "../services/getPerspektif";
import getSasaranStrategis from "../services/getSasaranStrategis";
import getIndikatorKinerja from "../services/getIndikatorKinerja";
import getFormula from "../services/getFormula";
import getPolarisasi from "../services/getPolarisasi";
import getTipeKonsolidasi from "../services/getTipeKonsolidasi";
import getSatuanCapaian from "../services/getSatuanCapaian";
import getStatusCapaian from "../services/getStatusCapaian";
import createCapaianIK from "../services/createCapaianIK";
import updateCapaianIK from "../services/updateCapaianIK";
import { InputField, SelectionField } from "../../../../CommonElements";
import NumberInputField from "../../../../CommonElements/Form/NumberInputFields";
import TabComponent from "./TabComponent";

const FormCapaianIK = ({ formCapaianIK, setFormCapaianIK, formType }) => {
  const axiosInstance = useAxios();
  const navigate = useNavigate();
  const [unitKerjaList, setUnitKerjaList] = useState([]);
  const [perspektifList, setPerspektifList] = useState([]);
  const [sasaranStrategisList, setSasaranStrategisList] = useState([]);
  const [indikatorKinerjaList, setIndikatorKinerjaList] = useState([]);
  const [formulaList, setFormulaList] = useState([]);
  const [polarisasiList, setPolarisasiList] = useState([]);
  const [tipeKonsolidasiList, setTipeKonsolidasiList] = useState([]);
  const [satuanCapaianList, setSatuanCapaianList] = useState([]);
  const [statusCapaianList, setStatusCapaianList] = useState([]);

  useEffect(() => {
    unitKerja();
    perspektif();
    sasaranStrategis();
    indikatorKinerja();
    formula();
    polarisasi();
    tipeKonsolidasi();
    satuanCapaian();
    statusCapaian();
  }, []);

  const unitKerja = () => {
    getUnitKerja(axiosInstance).then((res) => {
      setUnitKerjaList(res.data);
    });
  };

  const perspektif = () => {
    getPerspektif(axiosInstance).then((res) => {
      setPerspektifList(res.data);
    });
  };

  const sasaranStrategis = () => {
    getSasaranStrategis(axiosInstance).then((res) => {
      setSasaranStrategisList(res.data);
    });
  };

  const indikatorKinerja = () => {
    getIndikatorKinerja(axiosInstance).then((res) => {
      setIndikatorKinerjaList(res.data);
    });
  };

  const formula = () => {
    getFormula(axiosInstance).then((res) => {
      setFormulaList(res.data);
    });
  };

  const polarisasi = () => {
    getPolarisasi(axiosInstance).then((res) => {
      setPolarisasiList(res.data);
    });
  };

  const tipeKonsolidasi = () => {
    getTipeKonsolidasi(axiosInstance).then((res) => {
      setTipeKonsolidasiList(res.data);
    });
  };

  const satuanCapaian = () => {
    getSatuanCapaian(axiosInstance).then((res) => {
      setSatuanCapaianList(res.data);
    });
  };

  const statusCapaian = () => {
    getStatusCapaian(axiosInstance).then((res) => {
      setStatusCapaianList(res.data);
    });
  };

  const handleChangeForm = (e) => {
    const { name, value } = e.target;

    if (
      name === "anggaran" ||
      name === "komitmen" ||
      name === "aktual" ||
      name === "sisa_anggaran"
    ) {
      const numericValue = convertRPInputToIntValue(value);
      setFormCapaianIK((prev) => ({
        ...prev,
        [name]: numericValue,
      }));
    } 
    else if (name.startsWith("capaian_tw_")) {
      const numericValue = parseFloat(value) || 0;
      const triwulan = name.split("_")[2]; 
      
      let totalCapaian = 0;
      for (let i = 1; i <= parseInt(triwulan); i++) {
        if (i === parseInt(triwulan)) {
          totalCapaian += numericValue; 
        } else {
          totalCapaian += parseFloat(formCapaianIK[`capaian_tw_${i}`] || 0); // Nilai dari triwulan sebelumnya
        }
      }

      setFormCapaianIK((prev) => ({
        ...prev,
        [name]: numericValue,
        [`total_capaian_tw_${triwulan}`]: totalCapaian
      }));
    } 
    else {
      setFormCapaianIK((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const calculateTotal = () => {
    switch (formCapaianIK?.tipe_konsolidasi) {
      case "SUM":
        return (
          parseFloat(formCapaianIK?.target_tw_1) +
          parseFloat(formCapaianIK?.target_tw_2) +
          parseFloat(formCapaianIK?.target_tw_3) +
          parseFloat(formCapaianIK?.target_tw_4)
        );

      case "AVERAGE":
        return (
          (parseFloat(formCapaianIK?.target_tw_1) +
            parseFloat(formCapaianIK?.target_tw_2) +
            parseFloat(formCapaianIK?.target_tw_3) +
            parseFloat(formCapaianIK?.target_tw_4)) /
          4
        );

      case "LAST VALUE":
        return parseFloat(formCapaianIK?.target_tw_4);

      default:
        return 0;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formType === FORM_TYPE.Create) {
      createCapaianIK(axiosInstance, formCapaianIK).then(() => {
        console.log(APISentSuccessMsg);
        toast.success(getItemCreateSuccessMsg("capaian ik"), {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: timeToast,
        });
        navigate(`${process.env.PUBLIC_URL}/capaianik/`);
      });
    } else if (formType === FORM_TYPE.Edit) {
      updateCapaianIK(axiosInstance, formCapaianIK.id, formCapaianIK).then(
        () => {
          console.log(APISentSuccessMsg);
          toast.success(getItemEditSuccessMsg("capaian ik"), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: timeToast,
          });
          navigate(`${process.env.PUBLIC_URL}/capaianik/`);
        }
      );
    }
  };

  return (
    <Fragment>
      <Container fluid={true}>
        <Card>
          <CardHeader>
            <H4>Form Capaian IK</H4>
          </CardHeader>
          <CardBody>
            <Form>
              <Row>
                <Col md={6}>
                  <SelectionField
                    state={formCapaianIK}
                    label={"Unit Kerja"}
                    name={"unit_kerja"}
                    placeholder={"-------"}
                    defaultValue={formCapaianIK?.unit_kerja}
                    onChange={(e) => handleChangeForm(e)}
                    options={unitKerjaList}
                    optionsName={"nama_unit_kerja"}
                  />
                </Col>
                <Col md={6}>
                  <SelectionField
                    state={formCapaianIK}
                    label={"Perspektif"}
                    name={"perspektif"}
                    placeholder={"-------"}
                    defaultValue={formCapaianIK?.perspektif}
                    onChange={(e) => handleChangeForm(e)}
                    options={perspektifList}
                    optionsName={"nama_perspektif"}
                  />
                </Col>
                <Col md={6}>
                  <SelectionField
                    state={formCapaianIK}
                    label={"Kode Sasaran Strategis"}
                    name={"kode_ss"}
                    placeholder={"-------"}
                    defaultValue={formCapaianIK?.kode_ss}
                    onChange={(e) => handleChangeForm(e)}
                    options={sasaranStrategisList}
                    optionsName={"kode_sasaran_strategis"}
                  />
                </Col>
                <Col md={6}>
                  <SelectionField
                    state={formCapaianIK}
                    label={"Nama Sasaran Strategis"}
                    name={"nama_ss"}
                    placeholder={"-------"}
                    defaultValue={formCapaianIK?.nama_ss}
                    onChange={(e) => handleChangeForm(e)}
                    options={sasaranStrategisList}
                    optionsName={"nama_sasaran_strategis"}
                  />
                </Col>
                <Col ms={6}>
                  <NumberInputField
                    state={formCapaianIK}
                    label={"Kode IK"}
                    name={"kode_ik"}
                    defaultValue={formCapaianIK?.kode_ik}
                    onChange={(e) => handleChangeForm(e)}
                  />
                </Col>
                <Col md={6}>
                  <SelectionField
                    state={formCapaianIK}
                    label={"Nama IK"}
                    name={"nama_ik"}
                    placeholder={"-------"}
                    defaultValue={formCapaianIK?.nama_ik}
                    onChange={(e) => handleChangeForm(e)}
                    options={indikatorKinerjaList}
                    optionsName={"nama_indikator_kinerja"}
                  />
                </Col>
                <Col md={6}>
                  <SelectionField
                    state={formCapaianIK}
                    label={"Formula"}
                    name={"formula"}
                    placeholder={"-------"}
                    defaultValue={formCapaianIK?.formula}
                    onChange={(e) => handleChangeForm(e)}
                    options={formulaList}
                    optionsName={"nama_formula"}
                  />
                </Col>
                <Col md={6}>
                  <SelectionField
                    state={formCapaianIK}
                    label={"Polarisasi"}
                    name={"polarisasi"}
                    // placeholder={"-------"}
                    defaultValue={formCapaianIK?.polarisasi}
                    onChange={(e) => handleChangeForm(e)}
                    options={polarisasiList}
                    optionsName={"nama_polarisasi"}
                  />
                </Col>
                <Col md={6}>
                  <SelectionField
                    state={formCapaianIK}
                    label={"Tipe Konsolidasi"}
                    name={"tipe_konsolidasi"}
                    placeholder={"-------"}
                    defaultValue={formCapaianIK?.tipe_konsolidasi}
                    onChange={(e) => handleChangeForm(e)}
                    options={tipeKonsolidasiList}
                    optionsName={"nama_tipe_konsolidasi"}
                  />
                </Col>
                <Col md={6}>
                  <SelectionField
                    state={formCapaianIK}
                    label={"Satuan"}
                    name={"satuan_capaian"}
                    placeholder={"-------"}
                    defaultValue={formCapaianIK?.satuan_capaian}
                    onChange={(e) => handleChangeForm(e)}
                    options={satuanCapaianList}
                    optionsName={"nama_satuan_capaian"}
                  />
                </Col>
                <Col ms={6}>
                  <NumberInputField
                    state={formCapaianIK}
                    label={"Bobot IK"}
                    name={"bobot_ik"}
                    max="100"
                    min="0"
                    defaultValue={formCapaianIK?.bobot_ik}
                    onChange={(e) => handleChangeForm(e)}
                  />
                </Col>
                <Col md={6}>
                  <InputField
                    state={formCapaianIK}
                    label={"Link Upload"}
                    name={`uploaded_document`}
                    defaultValue={formCapaianIK?.[`uploaded_document`]}
                    onChange={(e) => handleChangeForm(e)}
                  />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col md={6}>
                  <InputField
                    state={formCapaianIK}
                    label={"Anggaran"}
                    name={"anggaran"}
                    defaultValue={formatRP(formCapaianIK?.anggaran)}
                    onChange={(e) => handleChangeForm(e)}
                  />
                </Col>
                <Col md={6}>
                  <InputField
                    state={formCapaianIK}
                    label={"Komitmen"}
                    name={"komitmen"}
                    defaultValue={formatRP(formCapaianIK?.komitmen)}
                    onChange={(e) => handleChangeForm(e)}
                  />
                </Col>
                <Col md={6}>
                  <InputField
                    state={formCapaianIK}
                    label={"Aktual"}
                    name={"aktual"}
                    defaultValue={formatRP(formCapaianIK?.aktual)}
                    onChange={(e) => handleChangeForm(e)}
                  />
                </Col>
                <Col md={6}>
                  <InputField
                    state={formCapaianIK}
                    label={"Sisa Anggaran"}
                    name={"sisa_anggaran"}
                    defaultValue={formatRP(formCapaianIK?.sisa_anggaran)}
                    onChange={(e) => handleChangeForm(e)}
                  />
                </Col>
              </Row>
              <div className="mt-5">
                <h4 className="text-center">Total Target Setahun</h4>
                <h5 className="text-center">
                  <Badge color="success">{calculateTotal()}</Badge>
                </h5>
              </div>
              <TabComponent>
                {(triwulan) => (
                  <Row>
                    <Col md="6">
                      <NumberInputField
                        state={formCapaianIK}
                        label={"Capaian"}
                        min="0"
                        max="999"
                        name={`capaian_tw_${triwulan}`}
                        defaultValue={formCapaianIK?.[`capaian_tw_${triwulan}`]}
                        onChange={(e) => handleChangeForm(e)}
                      />
                    </Col>
                    <Col md="6">
                      <NumberInputField
                        state={formCapaianIK}
                        label={"Target"}
                        name={`target_tw_${triwulan}`}
                        min="0"
                        max="999"
                        defaultValue={formCapaianIK?.[`target_tw_${triwulan}`]}
                        onChange={(e) => handleChangeForm(e)}
                      />
                    </Col>
                    <Col md="6">
                      <NumberInputField
                        state={formCapaianIK}
                        label={"Total Capaian"}
                        min="0"
                        max="999"
                        name={`total_capaian_tw_${triwulan}`}
                        defaultValue={
                          formCapaianIK?.[`total_capaian_tw_${triwulan}`]
                        }
                        onChange={(e) => handleChangeForm(e)}
                      />
                    </Col>
                    <Col md="6">
                      <NumberInputField
                        state={formCapaianIK}
                        label={"Total Target"}
                        min="0"
                        max="999"
                        name={`total_target_tw_${triwulan}`}
                        defaultValue={
                          formCapaianIK?.[`total_target_tw_${triwulan}`]
                        }
                        onChange={(e) => handleChangeForm(e)}
                      />
                    </Col>
                    <Col md="6">
                      <NumberInputField
                        state={formCapaianIK}
                        label={"Persentase Capaian"}
                        min="0"
                        max="999"
                        name={`persentase_capaian_tw_${triwulan}`}
                        defaultValue={
                          formCapaianIK?.[`persentase_capaian_tw_${triwulan}`]
                        }
                        onChange={(e) => handleChangeForm(e)}
                      />
                    </Col>
                    <Col md="6">
                      <NumberInputField
                        state={formCapaianIK}
                        label={"Persentase Capaian Normalisasi"}
                        min="0"
                        max="999"
                        name={`persentase_capaian_normalisasi_tw_${triwulan}`}
                        defaultValue={
                          formCapaianIK?.[
                            `persentase_capaian_normalisasi_tw_${triwulan}`
                          ]
                        }
                        onChange={(e) => handleChangeForm(e)}
                      />
                    </Col>
                    <Col md="6">
                      <NumberInputField
                        state={formCapaianIK}
                        label={"Nilai Indikator"}
                        min="0"
                        max="999"
                        name={`nilai_indikator_tw_${triwulan}`}
                        defaultValue={
                          formCapaianIK?.[`nilai_indikator_tw_${triwulan}`]
                        }
                        onChange={(e) => handleChangeForm(e)}
                      />
                    </Col>
                    <Col md="6">
                      <NumberInputField
                        state={formCapaianIK}
                        label={"Nilai Indikator Normalisasi"}
                        min="0"
                        max="999"
                        name={`nilai_indikator_normalisasi_tw_${triwulan}`}
                        defaultValue={
                          formCapaianIK?.[
                            `nilai_indikator_normalisasi_tw_${triwulan}`
                          ]
                        }
                        onChange={(e) => handleChangeForm(e)}
                      />
                    </Col>
                    <Col md={6}>
                      <SelectionField
                        state={formCapaianIK}
                        label={"Status"}
                        name={`status_tw_${triwulan}`}
                        // placeholder={"-------"}
                        defaultValue={formCapaianIK?.[`status_tw_${triwulan}`]}
                        onChange={(e) => handleChangeForm(e)}
                        options={statusCapaianList}
                        optionsName={"nama_status_capaian"}
                      />
                    </Col>
                    {/* <Col md={6}>
                      <InputField
                        state={formCapaianIK}
                        label={"Link Upload"}
                        name={`uploaded_document_tw_${triwulan}`}
                        defaultValue={formCapaianIK?.[`uploaded_document_tw_${triwulan}`]}
                        onChange={(e) => handleChangeForm(e)}
                      />
                    </Col> */}
                    <Col md="6">
                      <FormGroup>
                        <Label for={`last_uploaded_document_tw_${triwulan}`}>
                          Terakhir Upload Dokumen Pendukung (YYYY-MM-DD
                          hh:mm:ss)
                        </Label>
                        <Input
                          id={`last_uploaded_document_tw_${triwulan}`}
                          name={`last_uploaded_document_tw_${triwulan}`}
                          type="datetime"
                          value={
                            formCapaianIK?.[
                              `last_uploaded_document_tw_${triwulan}`
                            ]
                              ? formatTimestamp(
                                  formCapaianIK?.[
                                    `last_uploaded_document_tw_${triwulan}`
                                  ]
                                )
                              : "-"
                          }
                          onChange={(e) => handleChangeForm(e)}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <InputField
                        state={formCapaianIK}
                        label={"Keterangan/Kendala"}
                        name={`keterangan_tw_${triwulan}`}
                        defaultValue={
                          formCapaianIK?.[`keterangan_tw_${triwulan}`]
                        }
                        onChange={(e) => handleChangeForm(e)}
                      />
                    </Col>
                  </Row>
                )}
              </TabComponent>
              <div className="text-end">
                <Button
                  onClick={(e) => {
                    handleSubmit(e);
                  }}
                >
                  Submit
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Container>
    </Fragment>
  );
};

export default FormCapaianIK;
